import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import AuthPage from '../components/AuthPage'
import Header from '../components/Header'
import BusinessList from '../components/BusinessList'
import ScheduleCalendar from '../components/ScheduleCalendar'
import OutreachList from '../components/OutreachList'
import './HomePage.styles.scss'

export default function HomePage() {
  const { user } = useAuth()

  if (!user) {
    return <AuthPage />
  }

  return (
    <div className="home-container">
      <Header />

      <h1>Welcome {user.displayName}, Let&apos;s Outreach</h1>

      <BusinessList />

      <div className="calendar-outreach-wrapper">
        <div className="mini-calendar-section">
          <h2>Upcoming 7 Days</h2>
          {/* Pass the number 7 so it shows only the next week */}
          <ScheduleCalendar upcoming={7} />
          <Link to="/schedule" className="full-schedule-btn">
            Show Full Schedule
          </Link>
        </div>

        <div className="outreach-list-section">
          <h2>Your Outreach</h2>
          <OutreachList />
        </div>
      </div>
    </div>
  )
}
